import {SummaryModel} from "../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../common/entity/permissions.model";

export class InsolesModelSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    code: string;
    label: string;
}